import styled from 'styled-components';

import theme from '../../../styles/theme';

export const ModalBodyContainer = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  display: flex;

  background: ${theme.white};

  padding: 1px 20px 0px 20px;
  flex: 1;
`;
